export function urlValidation(url: string, t: CallableFunction): string {
  const refangedUrl = refangeUrl(url)

  try {
    const urlObj = new URL(refangedUrl)
    const isValid = urlObj.protocol === 'http:' || urlObj.protocol === 'https:'
    if (!isValid) {
      throw Error('Invalid protocol')
    }

    return ''
  } catch (e) {
    return t('Invalid URL')
  }
}

export function refangeUrl(url: string): string {
  let refangedUrl = url
  if (refangedUrl.startsWith('hxxps')) {
    refangedUrl = 'https' + refangedUrl.slice(5)
  } else if (refangedUrl.startsWith('hxxp')) {
    refangedUrl = 'http' + refangedUrl.slice(4)
  }
  refangedUrl = refangedUrl.replace('[://]', '://')
  refangedUrl = refangedUrl.split('[.]').join('.')
  return refangedUrl
}
